<script>
export default {
    name: "PhysicalExamPrint",

    data() {

        return {
            patient: {},
            physicalExam: {},
        };
    },

    mounted() {
        this.$root.loading=true;
        Promise.allSettled([ this.fetchPatient(), this.fetchPhysicalExam(), ]).then(() => {
            this.$root.loading=false;
            setTimeout(() => {
                window.print();
            }, 250);
        }).catch(() => { this.$root.loading=false; });
    },

    methods: {
        fetchPatient() {
            let url = `PatientRegistration/GetSpecificPatient`;
                url += `?PatientID=${this.$route.params.patientID}`;

            return this.$http.get(url).then(response => {
                this.patient = response.data.length ? response.data[0] : {};
            }).catch(() => {});
        },

        fetchPhysicalExam() {
            let url = `MedicalFile/GetSpecificPtMedicalFilePhysicalExam`;
                url += `?PhysicalExamId=${this.$route.params.physicalExamId}`;

            return this.$http.get(url).then(response => {
                this.physicalExam = response.data.length ? response.data[0] : {};
            }).catch(() => {});
        },
    },
}
</script>
<template>
<div class="w-full flex flex-wrap">
    <tail-address-header></tail-address-header>
    <div class="w-full text-center my-3">
        <h5 class="font-bold text-base uppercase">Physical Exam</h5>
    </div>
    <div class="w-full flex flex-wrap p-1 my-1 border-b-2 border-t-2 border-gray-800 mt-4">
        <div class="md:w-1/3 sm:w-1/3">
            <h5 class="text-sm"><span class="font-medium">Name:</span> {{ patient.names }}</h5>
        </div>
        <div class="md:w-1/3 sm:w-1/3">
            <h5 class="text-sm"><span class="font-medium">Visit No:</span> {{ patient.visitNo || `-` }}</h5>
        </div>
        <div class="md:w-1/3 sm:w-1/3">
            <h5 class="text-sm"><span class="font-medium">MRN:</span> {{ patient.patienT_ID }}</h5>
        </div>
    </div>
    <div class="w-full p-tiny mt-4">
        <span v-html="physicalExam.physicalExam"></span>
    </div>
</div>
</template>
